<template>
  <div class="trainer-manager">
    <container>
      <div class="trainer-manager__content">
        <div class="error" v-if="error">
          {{ error }}
        </div>

        <v-form :handle-submit="handleSubmit">
          <v-text-field
            name="firstName"
            @keyup.enter="handleSubmit"
            v-model="trainer.firstName"
            v-validate="'required'" data-vv-value-path="input" data-vv-name="firstName"
            :message-error="errors && errors.first ? errors.first('firstName') : ''"
            :has-error="errors && errors.has ? errors.has('firstName') : ''"
            :block="true">
            <template slot="label">
              First name: *
            </template>
          </v-text-field>

          <v-text-field
            name="lastName"
            @keyup.enter="handleSubmit"
            v-model="trainer.lastName"
            v-validate="'required'" data-vv-value-path="input" data-vv-name="lastName"
            :message-error="errors && errors.first ? errors.first('lastName') : ''"
            :has-error="errors && errors.has ? errors.has('lastName') : ''"
            :block="true">
            <template slot="label">
              Last name: *
            </template>
          </v-text-field>

          <v-text-field
            name="user.email"
            @keyup.enter="handleSubmit"
            v-model="trainer.user.email"
            v-validate="'required|email'" data-vv-value-path="input" data-vv-name="user.email"
            :message-error="errors && errors.first ? errors.first('user.email') : ''"
            :has-error="errors && errors.has ? errors.has('user.email') : ''"
            :block="true">
            <template slot="label">
              E-mail: *
            </template>
          </v-text-field>

          <v-text-field
            name="nickname"
            @keyup.enter="handleSubmit"
            v-model="trainer.nickname"
            v-validate="'required'" data-vv-value-path="input" data-vv-name="nickname"
            :message-error="errors && errors.first ? errors.first('nickname') : ''"
            :has-error="errors && errors.has ? errors.has('nickname') : ''"
            :block="true">
            <template slot="label">
              Nickname (username): *
            </template>
          </v-text-field>

          <v-text-field
            name="user.password"
            @keyup.enter="handleSubmit"
            type="password"
            v-model="trainer.user.password"
            v-validate="'required'" data-vv-value-path="input" data-vv-name="user.password"
            :message-error="errors && errors.first ? errors.first('user.password') : ''"
            :has-error="errors && errors.has ? errors.has('user.password') : ''"
            :block="true">
            <template slot="label">
              Password: *
            </template>
          </v-text-field>

          <v-text-field
            name="aboutMe"
            v-model="trainer.aboutMe"
            :block="true"
            :multiple-lines="true">
            <template slot="label">
              About me:
            </template>
          </v-text-field>

           <v-text-field
              name="introductionUrl"
              @keyup.enter="handleSubmit"
              v-model="trainer.introductionUrl"
               data-vv-value-path="input" data-vv-name="introductionUrl"
              :block="true">
              <template slot="label">
                Trainer Introduction Web : 
              </template>
            </v-text-field>


          <v-upload-field
            @fileUrl="setPhotoUrl"
            url="trainers/upload-image"
            :block="true">
            <template slot="label">
              Photo upload:
            </template>
          </v-upload-field>

          <v-button @click="handleSubmit" :block="true" :disabled="loading">
            {{ loading ? 'Loading...' : 'Save'}}
          </v-button>
        </v-form>
      </div>
    </container>
  </div>
</template>

<script>
import Container from '@/components/Container'
import PageTitle from '@/components/PageTitle'
import VForm from '@/components/Forms/VForm'
import VTextField from '@/components/Forms/VTextField'
import VUploadField from '@/components/Forms/VUploadField'
import VButton from '@/components/Forms/VButton'
import { mapActions } from 'vuex'

export default {
  name: 'TrainerManager',
  data: () => ({
    trainer: {
      aboutMe: '',
      firstName: '',
      lastName: '',
      nickname: '',
      photoUrl: null,
      user: {
        firstName: '',
        lastName: '',
        activated: true,
        email: '',
        langKey: 'en',
        login: '',
        password: ''
      }
    },
    loading: false,
    error: ''
  }),
  methods: {
    async handleSubmit () {
      const isValid = await this.$validator.validateAll()

      if (isValid) {
        this.loading = true

        const isAdded = await this.addTrainer(this.trainer)

        this.loading = false

        if (isAdded) {
          this.$router.push('/admin/trainers')

          return true
        }

        this.error = 'Something wrong while trying to add the trainer'

        return false
      }
    },
    setPhotoUrl (value) {
      this.trainer.photoUrl = value
    },
    ...mapActions({
      addTrainer: 'trainers/addTrainer'
    })
  },
  watch: {
    'trainer.firstName' () {
      this.trainer.user.firstName = this.trainer.firstName
    },
    'trainer.lastName' () {
      this.trainer.user.lastName = this.trainer.lastName
    },
    'trainer.nickname' () {
      this.trainer.user.login = this.trainer.nickname
    }
  },
  components: {
    Container,
    PageTitle,
    VButton,
    VForm,
    VTextField,
    VUploadField
  }
}
</script>

<style lang="stylus" scoped>
  .trainer-manager
    padding 0 0 30px

    &__content
      background #fff
      padding 15px 30px 30px
      box-shadow 0 2px 6px 0 rgba(0,0,0,0.2)
      max-width 60%

      .error
        padding 15px 30px
        margin 0 0 15px
        text-align center
        background #ff1744
        color #fff
        font-weight 700

      form
        label
          &:not(:last-of-type)
            margin-bottom 20px

        button
          margin 20px 0 0
</style>



// WEBPACK FOOTER //
// Add.vue?7c11862a